
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from "next"
import Head from "next/head"

import useBestsellerProducts from "@/graphql/hooks/useBestsellerProducts"
import getFilters from "@/graphql/requests/getFilters"
import SEO from "@/meta/SEO"
import { GoogleAnalytics } from "@/services/GA4/GoogleAnalytics"
import Default from "@/templates/Default"
import { FansiKindExtended } from "@/ts/Global"
import FilterGroup from "@/ts/interfaces/global/FilterGroup"
import useStaticProducts from "@/views/products/functions/useStaticProducts"
import ProductsGridView from "@/views/products-grid"

const FANSI_KIND: FansiKindExtended = "bestsellers"

function BestsellerProductsPage({
  staticFilters,
}: {
  staticFilters: FilterGroup
}) {
  const { filters } = useStaticProducts({
    staticFilters,
  })

  const { products, isLoading, count, maxPrice } = useBestsellerProducts()

  if (!filters) return null

  return (
    <>
      <Head>
        <title>Bestsellery | fansi.pl</title>
        <SEO description="Najpopularniejsze produkty, bestsellery od najlepszych Twórców, z którymi zadbasz o swój umysł, ciało i duszę, dom i bliskich. Unikalne, autorskie kolekcje, setki pomysłów na prezent dla Ciebie i tych, których kochasz." />
      </Head>
      <GoogleAnalytics />
      <ProductsGridView
        products={products}
        isLoading={isLoading}
        count={count}
        filters={filters}
        maxPrice={maxPrice}
        fansiKind={FANSI_KIND}
      />
    </>
  )
}

BestsellerProductsPage.Layout = Default

 const _getStaticProps: GetStaticProps = async () => {
  const staticFilters = await getFilters({ onlyCreators: false })

  return { props: { staticFilters }, revalidate: 1 }
}

export default BestsellerProductsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/bestsellers/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  